import { list } from './tags';

function endpoints(builder, tefafApi) {
  return {
    getBookmarkedElementIds: builder.query({
      query: (listType) => `actions/tefaf/user/bookmarks/get-item-element-ids?listType=${listType}`,
      providesTags: list,
    }),

    addBookmark: builder.mutation({
      invalidatesTags: list,
      query: ({
        listType,
        elementId,
      }) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'wishlist/items/add');
        body.append('elementId', elementId);
        body.append('listType', listType);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
      onQueryStarted({ listType, elementId }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          tefafApi.util.updateQueryData('getBookmarkedElementIds', listType, (draft) => {
            draft.items.push(elementId);
          }),
        );
        queryFulfilled.catch(patchResult.undo);
      },
    }),

    removeBookmark: builder.mutation({
      invalidatesTags: list,
      query: ({
        listType,
        elementId,
      }) => {
        const body = new FormData();
        body.append(window.CRAFT_CSRF_PARAM, window.CRAFT_CSRF_TOKEN);
        body.append('action', 'wishlist/items/remove');
        body.append('elementId', elementId);
        body.append('listType', listType);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
      onQueryStarted({ listType, elementId }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          tefafApi.util.updateQueryData('getBookmarkedElementIds', listType, (draft) => {
            const index = draft.items.indexOf(elementId);
            if (index > -1) {
              draft.items.splice(index, 1);
            }
          }),
        );
        queryFulfilled.catch(patchResult.undo);
      },
    }),
  };
}

export { endpoints };
